import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminSearchComponent } from './admin-search/admin-search.component';
import { LocationAdminComponent } from './location-admin/location-admin.component';
import { LocationGroupComponent } from './location-group/location-group.component';
import { UserAdminComponent } from './user-admin/user-admin.component';

const routes: Routes = [
  { path: 'user-admin', component: UserAdminComponent },
  { path: 'location-admin', component: LocationAdminComponent },
  { path: 'location-group', component: LocationGroupComponent },
  { path: 'admin-search', component: AdminSearchComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
